import React from 'react'
import * as S from './styles'

import { Modal } from '@mui/material'

interface IModalFullScreenProps {
  children?: React.ReactNode
  isOpen: boolean
  onCloseModal?: () => void
}

const ModalFullScreen = ({
  children,
  isOpen,
  onCloseModal,
}: IModalFullScreenProps) => {
  return (
    <Modal
      open={isOpen}
      onClose={onCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      container={() => document.getElementById('root')}
    >
      <S.Container>
        <S.Body>{children}</S.Body>
      </S.Container>
    </Modal>
  )
}

export { ModalFullScreen }
export type { IModalFullScreenProps }
